import React from "react"
import {FieldTableCellProps} from "../../../../render/table/table-cell";

export default function FieldEstimatedCost_TableCell(props:FieldTableCellProps):React.ReactElement {

    // this is common part for table cell

    const width = props.column.width ? props.column.width : props.manager.columnsManager.getColumnWidth(props.column)

    const style : style = _.clone(props.style) || {} // we need clone here because we add width!
    style.width = width

    let cellContent : any   = null
    const model : any       = props.listItem.item //
    const fieldAccess       = props.field.access(model)

    // end common part

    // never editable so no tableView / tableEditable components done
    // also here we use listItem data not model data (which is not good) but that's how it is

    // @ts-ignore
    const cost : any            = props.listItem[props.field.fieldId] // this is object iwth 3 keys own, total, children
    let showSumIcon : boolean   = false
    let value       : number    = 0

    // when collapsed show combined reported time from this item and its children
    if (props.listItem.isCollapsed && props.listItem.childrenItems.length > 0) {
        value       = cost.total
        showSumIcon = !!cost.children
    } else {
        value       = cost.own
    }

    // if value = 0 we show nothing

    if (!fieldAccess || !value) {
        cellContent = null
    } else {
        const dataModel : any       = {}
        dataModel[props.field.fieldId] = value
        cellContent = <props.field.renderComponents.viewSmall className={props.className}
                                                                  field = {props.field}
                                                                  model = {dataModel}
        />
    }

    return (
        <div className={Classes("cell flex-r fl-ac", props.column.id)} style={style} >
            {showSumIcon && <div className="ui5-ico-12 i5-summary-symbol m-r-5"/>}
            {cellContent}
        </div>
    )

}
